import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { RouterModule } from '@angular/router';
import { ArticuloCardComponent } from './articulo-card/articulo-card.component';
import { LogoComponent } from './logo/logo.component';
import { InstitucionPaginatorComponent } from './institucion-paginator/institucion-paginator.component';
import { InstitucionGmapComponent } from './institucion-gmap/institucion-gmap.component';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { SnackAlertaComponent } from './snack-alerta/snack-alerta.component';
import { LoaderComponent } from './loader/loader.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ModalHorariosComponent } from './modal-horarios/modal-horarios.component';
import { ImgLoaderComponent } from './img-loader/img-loader.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { ImgGalleryComponent } from './img-gallery/img-gallery.component';
import { NgxsModule } from '@ngxs/store';
import { SearchState } from 'src/app/store/search/search.state';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ArticuloCardComponent,
    LogoComponent,
    InstitucionPaginatorComponent,
    InstitucionGmapComponent,
    SnackAlertaComponent,
    LoaderComponent,
    ModalHorariosComponent,
    ImgLoaderComponent,
    ImgGalleryComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD981gn_utZE-OPLTEzVTGyXnX2mNivJIc',
    }),
    AgmSnazzyInfoWindowModule,
    SlickCarouselModule,
    LazyLoadImageModule,
    ContentLoaderModule,

  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ArticuloCardComponent,
    InstitucionPaginatorComponent,
    InstitucionGmapComponent,
    SnackAlertaComponent,
    LoaderComponent,
    ModalHorariosComponent,
    ImgLoaderComponent,
    ImgGalleryComponent
  ],
})
export class GlobalesComponentsModule {}
